import { render, staticRenderFns } from "./my_news_list.vue?vue&type=template&id=039e2736&scoped=true"
import script from "./my_news_list.vue?vue&type=script&lang=js"
export * from "./my_news_list.vue?vue&type=script&lang=js"
import style0 from "./my_news_list.vue?vue&type=style&index=0&id=039e2736&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039e2736",
  null
  
)

export default component.exports